import { motion } from "motion/react";
import { Settings, Telescope } from "lucide-react";
import { SectionLabel } from "@/components/common/SectionLabel";
import { ANIMATION_VARIANTS } from "@/constants/animations";
import { COMPANY_INFO } from "@/constants/company";
import aboutImg from "@/assets/images/ServicioSeguridadTrabajo.webp";

export function AboutSection() {
  const values = [
    {
      icon: Settings,
      title: "Misión",
      text: COMPANY_INFO.mission,
    },
    {
      icon: Telescope,
      title: "Visión",
      text: COMPANY_INFO.vision,
    },
  ];

  return (
    <section id="nosotros" className="py-[120px] bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Imagen */}
        <motion.div
          variants={ANIMATION_VARIANTS.fadeLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="relative h-[560px] rounded-lg overflow-hidden shadow-2xl border border-[#A5E0DF]/30"
        >
          <img
            src={aboutImg}
            alt="Equipo de Ingenieros"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#0A2540]/20 mix-blend-multiply" />
          <div className="absolute bottom-6 left-6 bg-[#0A2540]/95 backdrop-blur-md text-white px-6 py-5 rounded-lg border border-white/10">
            <div className="text-[#39B5BF] font-black text-4xl leading-none mb-1">
              +15
            </div>
            <div className="text-xs font-bold uppercase tracking-widest text-white/90">
              Años de experiencia
            </div>
          </div>
        </motion.div>

        {/* Texto */}
        <motion.div
          variants={ANIMATION_VARIANTS.fadeRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <SectionLabel text="Quiénes Somos" />
          <h2 className="text-4xl font-bold text-[#0A2540] mb-8 max-w-lg leading-snug">
            {COMPANY_INFO.aboutTitle}
          </h2>
          <p className="text-[#0A2540]/80 mb-6 text-[16px] md:text-[18px] font-normal leading-[1.7] max-w-xl">
            {COMPANY_INFO.aboutText1}
          </p>
          <p className="text-[#0A2540]/80 mb-12 text-[16px] md:text-[18px] font-normal leading-[1.7] max-w-xl">
            {COMPANY_INFO.aboutText2}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map(({ icon: Icon, title, text }) => (
              <div key={title} className="flex gap-4 group">
                <div className="shrink-0 w-12 h-12 rounded-lg bg-[#39B5BF]/10 flex items-center justify-center group-hover:bg-[#39B5BF]/20 transition-colors border border-[#39B5BF]/20">
                  <Icon className="w-6 h-6 text-[#39B5BF]" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-bold text-[#0A2540] mb-2">{title}</h3>
                  <p className="text-[#0A2540]/75 text-[15px] font-normal leading-[1.7]">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}